import {IGenericKeyValue} from '../_interface/itemplate-field';
import {flatten} from 'flat';

export const bodyToKeyValue = (input: any ): IGenericKeyValue[] => {
	const flat = flatten(input);
	const entries = Object.entries(flat);
	return entries.map(([key, value]) => ({key, value}));
};
